import { render, staticRenderFns } from "./BuyerTicketFilters.vue?vue&type=template&id=85c907dc&"
import script from "./BuyerTicketFilters.vue?vue&type=script&lang=js&"
export * from "./BuyerTicketFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports